import { render, staticRenderFns } from "./FailureModeRvs.vue?vue&type=template&id=06be824a&scoped=true"
import script from "./FailureModeRvs.vue?vue&type=script&lang=ts"
export * from "./FailureModeRvs.vue?vue&type=script&lang=ts"
import style0 from "./FailureModeRvs.vue?vue&type=style&index=0&id=06be824a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be824a",
  null
  
)

export default component.exports